import { Page } from "../shell/Page";

export function Placeholder({ title, note }: { title: string; note: string }) {
  return (
    <Page title={title} lede={note}>
      <div className="rounded-lg border border-dashed bg-card px-4 py-10 text-center text-sm text-muted-foreground">Built in the next slice of S5. The signed frame is in mockups/signed-language.html.</div>
    </Page>
  );
}
